export default {
  "content": "<circle cx=\"12\" cy=\"12\" r=\"6\"/>",
  "attrs": {
    "viewBox": "0 0 24 24",
    "height": "24",
    "width": "24"
  }
};